import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import TableCard from "./TableCard";
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';

const ExercisesTable = ({ data, handleDelete }) => {
  const [searchTerm, setSearchTerm] = useState("");


  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  let filteredData = data;

  if (searchTerm && data) {
    filteredData = filteredData.filter(workout => 
      workout.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }
  const config = [
    {
      key: 'Id',
      label: 'Id',
      render: (exercise) => exercise.id,
      rowClassname: 'whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6',
      columnClassname: 'py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6',
    },
    {
      key: 'Name',
      label: 'Name',
      render: (exercise) => exercise.name,
      rowClassname: 'whitespace-nowrap px-3 py-4 text-sm text-gray-500',
      columnClassname: 'px-3 py-3.5 text-left text-sm font-semibold text-gray-900',
    },
    {
      key: 'Is KPI?',
      label: 'Is KPI?',
      render: (exercise) => exercise.is_kpi? "Yes":"No",
      rowClassname: 'whitespace-nowrap px-3 py-4 text-sm text-gray-500',
      columnClassname: 'px-3 py-3.5 text-left text-sm font-semibold text-gray-900',
    },
    {
      key: 'Edit',
      label: '',
      render: (exercise) => <NavLink to={`/exercise/${exercise.id}`} className="text-indigo-600 hover:text-indigo-900">
        Edit<span className="sr-only">, {exercise.name}</span>
        </NavLink>,
      rowClassname: 'relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6',
      columnClassname: 'px-3 py-3.5 text-left text-sm font-semibold text-gray-900',
    },
    {
      key: 'Delete',
      label: '',
      render: (exercise) => <NavLink to="/" onClick={(e)=>handleDelete(e,exercise.id)} className="text-indigo-600 hover:text-indigo-900">
        Delete<span className="sr-only">{exercise.name}</span>
        </NavLink>,
      rowClassname: 'relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6',
      columnClassname: 'px-3 py-3.5 text-left text-sm font-semibold text-gray-900',
    },
  ];

  const keyFn = (workout) => {
    return workout.id;
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="flex items-center ml-8 mb-4 mt-8">
        
        <div className="relative">
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearch}
            placeholder="Search exercises"
            className="rounded-md border-gray-300 px-4 py-2 pl-10"
          />
          <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
        </div>
      </div>
      <TableCard data={filteredData} config={config} keyFn={keyFn} />
    </div>
  );
};

export default ExercisesTable;
